import { withPage } from "@myloc/myloc-utils";
import PropType from "prop-types";
import { useParams } from "react-router";
import useOrderWizard from "../../../hooks/useOrderWizard";
import { useTranslate } from "../../../language/i18n";
import pages from "../../../utils/pages";
import AdditionalInfo from "../../shared/AdditionalInfo/AdditionalInfo";
import AddressAndContact from "../../shared/AddressAndContact/AddressAndContact";
import OrderOverview from "../../shared/OrderOverview/OrderOverview";
import WizardPage, { getActiveStep } from "../../shared/WizardPage/WizardPage";
import OrderInfo from "./OrderInfo";
import Product from "./Product";

const ExternalAssortmentPage = ({ currentActiveStep }) => {
  const queryParams = useParams();
  const translate = useTranslate();
  const { data, setData, stepper, handleNext } = useOrderWizard(pages.PRODUCTS_EXTERNAL_ASSORTMENT.PATH, {
    contentType: "NEW_PRODUCT",
    product: { quantity: 1 },
  });

  const steps = [
    {
      title: translate("ADD_PRODUCT"),
      titleShort: translate("PRODUCT"),
      children: <Product data={data} setData={setData} onNext={handleNext} />,
    },
    {
      title: translate("ADD_ADDITIONAL_INFO"),
      titleShort: translate("ADDITIONAL_INFO_SHORT"),
      children: <AdditionalInfo onNext={handleNext} />,
    },
    {
      title: translate("ADD_DELIVERY_ADDRESS_AND_CONTACT"),
      titleShort: translate("ADDRESS"),
      children: <AddressAndContact onNext={handleNext} showDeliveryMethods={true} data={data} />,
    },
    {
      title: translate("ORDER_OVERVIEW"),
      titleShort: translate("ORDER_OVERVIEW_SHORT"),
      children: (
        <OrderOverview>
          <OrderInfo />
        </OrderOverview>
      ),
    },
  ];
  return (
    <WizardPage
      title={translate("EXTERNAL_ASSORTMENT_TITLE")}
      steps={steps}
      activeStep={getActiveStep(queryParams.content, currentActiveStep, data.currentStep)}
      setActiveStep={step => stepper.setActiveStep(step)}
    />
  );
};

ExternalAssortmentPage.propTypes = {
  search: PropType.string,
  id: PropType.string,
  currentStep: PropType.number,
  currentActiveStep: PropType.number,
};

export default withPage(ExternalAssortmentPage);
